<template>
  <b-col
    class="form-box card-data-block"
    :class="customClass"
  >
    <div
      v-if="patient"
      class="structure"
    >
      <span class="structure__heading">
        <i
          class="far fa-user mr-2"
          aria-hidden="true"
        />
        {{ $t('global.personalData') }}
      </span>
      <b-row class="mt-1">
        <b-col
          lg="4"
          md="6"
        >
          <div class="structure__data">
            <small>{{ $tc('global.name') }}</small>
            <h4
              v-testing="'patient-name'"
              class="collapsable-card-title inside"
            >
              {{ patient.patName }}
            </h4>
          </div>
        </b-col>
        <b-col
          v-if="patient.patMiddleName"
          lg="4"
          md="6"
        >
          <div class="structure__data">
            <small>{{ $t('global.middleName') }}</small>
            <h4
              v-testing="'patient-middleName'"
              class="collapsable-card-title inside"
            >
              {{ patient.patMiddleName }}
            </h4>
          </div>
        </b-col>
        <b-col
          lg="4"
          md="6"
        >
          <div class="structure__data">
            <small>{{ $t('global.surname1') }}</small>
            <h4
              v-testing="'patient-surname1'"
              class="collapsable-card-title inside"
            >
              {{ patient.patSurname1 }}
            </h4>
          </div>
        </b-col>
        <b-col
          lg="4"
          md="6"
        >
          <div class="structure__data">
            <small>{{ $t('global.surname2') }}</small>
            <h4
              v-testing="'patient-surname2'"
              class="collapsable-card-title inside"
            >
              {{ patient.patSurname2 }}
            </h4>
          </div>
        </b-col>
        <b-col
          lg="4"
          md="6"
        >
          <div class="structure__data">
            <small>{{ $t('global.birthday') }}</small>
            <h4
              v-testing="'patient-birthday'"
              class="collapsable-card-title inside"
            >
              {{ patient.patBirthdate | date }}
            </h4>
          </div>
        </b-col>
        <b-col
          lg="4"
          md="6"
        >
          <div class="structure__data">
            <small>{{ $t('global.age') }}</small>
            <h4
              v-testing="'patient-age'"
              class="collapsable-card-title inside"
            >
              {{ getPatientTimeOld(patient.patBirthdate) }}
            </h4>
          </div>
        </b-col>
        <b-col
          lg="4"
          md="6"
        >
          <div class="structure__data">
            <small>{{ $t('entities.patient.gender') }}</small>
            <h4
              v-testing="'patient-gender'"
              class="collapsable-card-title inside"
            >
              {{ patientGenderName }}
            </h4>
          </div>
        </b-col>
      </b-row>
    </div>
    <div
      v-else
      class="empty-block my-3"
      style="opacity: .2"
    />
  </b-col>
</template>

<script>
export default {
    name: 'PatientPersonalDataCard',
    props: {
        patient: { type: Object, default: null },
        customClass: { type: Array }
    },
    computed: {
        patientGenderName() {
            return this.patient.gender?.name ?? '-'
        }
    }
}
</script>

<style scoped>

</style>
